export enum ActivityNature {
  Comment,
  ProjectAbandoned,
  ProjectCreated,
  PaymentDone,
  ProjectReactivated,
  StatusChanged
}
